import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class CommissionsAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

  getOneError() {
    const message = {
      body: 'COMMISSIONS_GET_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'COMMISSIONS_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'COMMISSIONS_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'COMMISSIONS_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'COMMISSIONS_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess() {
    const message = {
      body: 'COMMISSIONS_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'COMMISSIONS_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD_COMMISSIONS_TO_CONSOLIDATED //
  addCommissionsToConsolidatedSuccess() {
    const message = {
      body: 'COMMISSIONS_ADD_COMMISSIONS_TO_CONSOLIDATED_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addCommissionsToConsolidatedError() {
    const message = {
      body: 'COMMISSIONS_ADD_COMMISSIONS_TO_CONSOLIDATED_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE_COMMISSIONS_FROM_CONSOLIDATED //
  removeCommissionsFromConsolidatedSuccess() {
    const message = {
      body: 'COMMISSIONS_REMOVE_COMMISSIONS_FROM_CONSOLIDATED_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeCommissionsFromConsolidatedError() {
    const message = {
      body: 'COMMISSIONS_REMOVE_COMMISSIONS_FROM_CONSOLIDATED_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD_CREDIT //
  addCreditSuccess() {
    const message = {
      body: 'COMMISSIONS_ADD_CREDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addCreditError() {
    const message = {
      body: 'COMMISSIONS_ADD_CREDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD_DEBIT //
  addDebitSuccess() {
    const message = {
      body: 'COMMISSIONS_ADD_DEBIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addDebitError() {
    const message = {
      body: 'COMMISSIONS_ADD_DEBIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // PAY_MANUALLY //
  PayManuallySuccess() {
    const message = {
      body: 'COMMISSIONS_PAY_MANUALLY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  PayManuallyError() {
    const message = {
      body: 'COMMISSIONS_PAY_MANUALLY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // PAY_CONSOLIDATED_MANUALLY //
  PayConsolidatedManuallySuccess() {
    const message = {
      body: 'COMMISSIONS_PAY_CONSOLIDATED_MANUALLY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  PayConsolidatedManuallyError() {
    const message = {
      body: 'COMMISSIONS_PAY_CONSOLIDATED_MANUALLY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  exportSuccess() {
    const message = {
      body: 'COMMISSIONS_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'COMMISSIONS_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.commissions')
  .service('commissionsAlertsService', CommissionsAlertsService);
